.color-container {
  margin-top: 1.75rem;
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.color-cubes {
  display: flex;

  &:last-of-type {
    margin-right: 0;
  }
}

.color-cube {
  height: 3.2rem;
  width: 3.2rem;
  border-radius: 0.4rem;
  border: solid 2px transparent;
  margin-right: 1.25rem;
  cursor: pointer;

  &:last-of-type {
    margin-right: 0;
  }

  &[data-selected='true'] {
    border: solid 2px #ffffff;
  }
}
